import React from 'react';
import { Hint, HintProps } from '../Hint';
import { useNewNavigationOnboarding } from '../AppLayout/MasterLayout/NewNavigationOnboardingContext';

interface NewNavigationOnboardingHintProps {
  open: boolean;
  children: JSX.Element;
  step: string;
  description: string;
  placement: HintProps['placement'];
  buttonText: string;
  offset?: HintProps['offset'];
  disablePortal?: boolean;
  mobilePlacement?: HintProps['mobilePlacement'];
  hideActions?: boolean;
  width?: number;
  onClose?: () => void;
}

const NewNavigationOnboardingHint = ({
  open,
  children,
  step,
  description,
  placement,
  buttonText,
  offset = { x: 12 }, // Default 12px horizontal offset provides visual spacing between the hint and its target element
  disablePortal = false,
  mobilePlacement,
  hideActions = false,
  width,
  onClose,
}: NewNavigationOnboardingHintProps) => {
  const onboardingStepCounter = useNewNavigationOnboarding();

  return (
    <Hint
      description={description}
      open={open}
      onClose={onClose || onboardingStepCounter.dismissWalkthrough}
      actions={hideActions ? undefined : {
        secondary: {
          label: buttonText,
          onClick: () => onboardingStepCounter.incrementStep(),
          buttonProps: {
            variant: 'text'
          },
        },
      }}
      offset={offset}
      placement={placement}
      disablePortal={disablePortal}
      mobilePlacement={mobilePlacement}
      bottomLeftText={step}
      width={width}
    >
      {children}
    </Hint>
  );
};

export default NewNavigationOnboardingHint;
